<template>
  <div class="flex flex-col gap-y-4">
    <review-details />
    <review-dates-and-states />
    <review-perils />
  </div>
</template>

<script setup>
import ReviewDetails from './review-overview.vue'
import ReviewDatesAndStates from './review-dates-and-states.vue'
import ReviewPerils from './review-perils.vue'
</script>
